<div class="page page--grey-bg" id="page-top">
  <app-loader></app-loader>
  <app-side-navigation class="site-nav"></app-side-navigation>
  <main class="page__main">
    <div class="wrap">
      <router-outlet></router-outlet>
    </div>
  </main>
  <app-footer></app-footer>
</div>
